import React from 'react';
import {
  BrFilter,
  ProductFilterInput,
  SearchProductsSortFragment,
} from '../../../../generated/product-service-graphql';
import { pluralize } from 'src/scripts/utils/helpers';
import StickyFiltersMenu from '../../product-listing-page/components/StickyFiltersMenu';

const SearchPageHeader = ({
  query,
  resultsQuantity,
  openPlpFiltersDrawer,
  totalAppliedFilterCount,
  isMobile,
  sortOptions,
  filters,
  selectedFilters,
}: {
  query: string;
  resultsQuantity?: number;
  openPlpFiltersDrawer: () => void;
  totalAppliedFilterCount: number;
  isMobile: boolean;
  sortOptions: SearchProductsSortFragment[];
  filters: BrFilter[];
  selectedFilters: ProductFilterInput[];
}) => {
  return (
    <>
      <div className="search-header-text-container">
        <p className="search-header-text body-large">
          {resultsQuantity ? `${pluralize(resultsQuantity, `result`)}` : 'Loading results'} for "
          <span className="query body-large bold">{query}</span>"
        </p>
      </div>
      <StickyFiltersMenu
        totalAppliedFilterCount={totalAppliedFilterCount}
        openPlpFiltersDrawer={openPlpFiltersDrawer}
        isMobile={isMobile}
        sortOptions={sortOptions}
        filters={filters}
        selectedFilters={selectedFilters}
      />
    </>
  );
};

export default SearchPageHeader;
